import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { AuthContext } from '../../context/AuthContext';

const PrivateRoute = ({ children }) => {
  // 認証チェックを一時的にバイパス
  return children;
  
  // 元のコード
  // const { currentUser, loading } = useContext(AuthContext);
  // if (loading) {
  //   return <div>Loading...</div>;
  // }
  // if (!currentUser) {
  //   return <Navigate to="/login" />;
  // }
  // return children;
};

export default PrivateRoute;
